"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPNotification = void 0;
var react_1 = __importDefault(require("react"));
//Componentes do Material UI
var core_1 = require("@material-ui/core");
var Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
//styles
var theme_1 = require("../../globals/theme");
var styles_1 = require("./styles");
require("../../assets/style.css");
var PPGrid_1 = require("../PPGrid/PPGrid");
function Alert(props) {
    return react_1.default.createElement(Alert_1.default, __assign({ elevation: 6, variant: "filled" }, props));
}
/**
 * Componente de notificação
 * @param {NotificationInterface} props Propriedades
 */
var PPNotification = function (props) {
    var classes = (0, styles_1.useStyles)();
    var Icon = function () {
        if (props.severity === 'success') {
            return react_1.default.createElement("i", { className: "ppi ppi-check", id: "iconNotify" });
        }
        else if (props.severity === 'error') {
            return react_1.default.createElement("i", { className: "ppi ppi-exclamation-circle", id: "iconNotify" });
        }
        else if (props.severity === 'info') {
            return react_1.default.createElement("i", { className: "ppi ppi-information-circle", id: "iconNotify" });
        }
        else if (props.severity === 'warning') {
            return react_1.default.createElement("i", { className: "ppi ppi-exclamation", id: "iconNotify" });
        }
        else {
            return react_1.default.createElement("i", { className: "ppi ppi-information-circle", id: "iconNotify" });
        }
        ;
    };
    var ColorDefault = function () {
        if (props.severity === 'success') {
            return classes.colorSuccess;
        }
        else if (props.severity === 'error') {
            return classes.colorError;
        }
        else if (props.severity === 'info') {
            return classes.colorInfo;
        }
        else if (props.severity === 'warning') {
            return classes.colorWarning;
        }
        else {
            return classes.colorDefault;
        }
        ;
    };
    function renderContents() {
        return (react_1.default.createElement(PPGrid_1.PPGrid, { contents: props.contents, cssClass: "default" }));
    }
    return (react_1.default.createElement(core_1.ThemeProvider, { theme: theme_1.theme },
        react_1.default.createElement(core_1.Snackbar, { open: props.valueAppear, autoHideDuration: props.duration, onClose: props.closeNotify, anchorOrigin: {
                vertical: props.verticalPosition ? props.verticalPosition : 'top',
                horizontal: props.horizontalPosition ? props.horizontalPosition : 'center'
            }, key: props.verticalPosition + props.horizontalPosition },
            react_1.default.createElement(Alert, { icon: props.icon ? Icon() : false, onClose: props.closeNotify, severity: props.severity, variant: props.severity ? "filled" : "standard", className: ColorDefault(), action: props.closeButton === true ? react_1.default.createElement(core_1.Button, { color: "inherit", size: "small", className: classes.closeButton },
                    react_1.default.createElement("i", { className: "ppi ppi-x", id: "closeIcon" })) : react_1.default.createElement(react_1.default.Fragment, null) },
                props.contents ? renderContents() : props.message,
                (props.link === true && props.messageLink) || props.messageLink ? react_1.default.createElement(core_1.Link, { className: classes.linkColor }, props.messageLink) : react_1.default.createElement(react_1.default.Fragment, null)))));
};
exports.PPNotification = PPNotification;
